<py-checkbox [showLabel]="true">
  <input type="checkbox" [(ngModel)]="fullPalletNote" (click)="toggleEntryFullPalletNote()" />
  <span slot="label">{{ 'checkout.fullPalletsOnly_heading' | cxTranslate }}</span>
</py-checkbox>
